export default "__VITE_ASSET__ByvvUbx0__"